"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BuilderClass = /** @class */ (function () {
    function BuilderClass(opts) {
        this.opts = opts;
    }
    BuilderClass.prototype.default = function (value) {
        return __assign({}, this.opts, { required: false, default: value });
    };
    Object.defineProperty(BuilderClass.prototype, "required", {
        get: function () {
            return __assign({}, this.opts, { required: true });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuilderClass.prototype, "optional", {
        get: function () {
            return __assign({}, this.opts, { required: false });
        },
        enumerable: true,
        configurable: true
    });
    BuilderClass.prototype.validator = function (validator) {
        return new BuilderClass(__assign({}, this.opts, { validator: validator }));
    };
    Object.defineProperty(BuilderClass.prototype, "or", {
        get: function () {
            var type = this.opts.type || [];
            var types = type instanceof Array ? type : [type];
            return createBuilderCollection(types);
        },
        enumerable: true,
        configurable: true
    });
    return BuilderClass;
}());
function createBuilder(baseTypes) {
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        types[_i - 1] = arguments[_i];
    }
    var newTypes = baseTypes.concat(types);
    return new BuilderClass({
        type: newTypes.length === 1 ? newTypes[0] : newTypes
    });
}
function createBuilderCollection(baseTypes) {
    var ret = (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return createBuilder.apply(void 0, [baseTypes].concat(args));
    });
    var namedBuilders = {
        ofFunction: function () {
            return createBuilder(baseTypes, Function);
        },
        ofArray: function () {
            return createBuilder(baseTypes, Array);
        },
        ofRoArray: function () {
            return createBuilder(baseTypes, Array);
        },
        ofObject: function () {
            return createBuilder(baseTypes, Object);
        },
        ofStringLiterals: function () {
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            return new BuilderClass({
                type: String,
                validator: function (v) { return values.indexOf(v) >= 0; }
            });
        },
        ofAny: function () {
            return new BuilderClass({});
        },
        ofType: function () {
            return new BuilderClass({});
        }
    };
    return Object.assign(ret, namedBuilders);
}
var rootBuilders = createBuilderCollection([]);
exports.default = rootBuilders;
//# sourceMappingURL=data:application/json;base64,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